<!-- FAB -->
<button
  class="chatbot-fab"
  (click)="toggle()"
  [attr.aria-label]="isOpen() ? 'Cerrar chat' : 'Abrir chat'"
  [attr.aria-expanded]="isOpen()"
>
  @if (isOpen()) {
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  } @else {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  }
</button>

<!-- Popup panel -->
@if (isOpen()) {
  <div class="chatbot-panel" role="dialog" aria-label="Asistente ChircalNet">
    <!-- Header -->
    <div class="chatbot-header">
      <div class="chatbot-header__avatar">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          <circle cx="12" cy="16" r="1"></circle>
        </svg>
      </div>
      <div class="chatbot-header__info">
        <span class="chatbot-header__name">Asistente ChircalNet</span>
        <span class="chatbot-header__status">
          <span class="chatbot-header__dot"></span>
          En línea
        </span>
      </div>
      <button class="chatbot-header__close" (click)="toggle()" aria-label="Cerrar chat">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Messages -->
    <div class="chatbot-messages">
      @for (msg of chatService.messages(); track $index) {
        <div class="chatbot-message" [class.chatbot-message--user]="msg.role === 'user'">
          <div class="chatbot-message__bubble" [innerHTML]="formatMessage(msg.content)"></div>
        </div>
      }

      @if (chatService.loading()) {
        <div class="chatbot-message">
          <div class="chatbot-message__bubble chatbot-message__bubble--typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      }

      <div #messagesEnd></div>
    </div>

    <!-- Input -->
    <div class="chatbot-footer">
      <textarea
        class="chatbot-footer__input"
        [(ngModel)]="inputText"
        [ngModelOptions]="{ standalone: true }"
        (keydown)="onKeydown($event)"
        placeholder="Escribe tu mensaje..."
        rows="1"
        [disabled]="chatService.loading()"
        aria-label="Escribe un mensaje"
      ></textarea>
      <button
        class="chatbot-footer__send"
        (click)="send()"
        [disabled]="chatService.loading() || !inputText().trim()"
        aria-label="Enviar mensaje"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </button>
    </div>
  </div>
}
